import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { clearSession } from "../../pages/services/SessionManager";

const SidebarNav = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;


  const [isSideMenu, setSideMenu] = useState("");

  const toggleSidebar = (value) => {
    setSideMenu(value);
  };


  const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMouseOverSidebar, setMouseOverSidebar] = useState(false);

  useEffect(() => {
    if (isMouseOverSidebar && document.body.classList.contains("mini-sidebar")) {
      document.body.classList.add("expand-menu");
      return;
    }
    document.body.classList.remove("expand-menu");
  }, [isMouseOverSidebar]);

  const handleMouseEnter = () => {
    setMouseOverSidebar(true);
  };

  const handleMouseLeave = () => {
    setMouseOverSidebar(false);
  };

  const handleLogout = () => {
    clearSession();
    navigate('/login');
    window.location.reload(); // Ensure complete cleanup
  };

  return (
    <div
      className={`sidebar ${isSidebarExpanded ? "" : "hidden"}`}
      id="sidebar"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Scrollbars
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        autoHeight
        autoHeightMin={0}
        autoHeightMax="95vh"
        thumbMinSize={30}
        universal={false}
        hideTracksWhenNotNeeded={true}
      >
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li
                className={
                  pathname && pathname.includes("dashboard") ? "active" : ""
                }
              >
                <Link to="/dashboard">
                  <i className="fe fe-home" /> <span>Dashboard</span>
                </Link>
              </li>
              <li
                className={
                  pathname && pathname.includes("appointmentList") ? "active" : ""
                }
              >
                <Link to="/appointmentList">
                  <i className="fas fa-calendar-check" /> <span>Appointments</span>
                </Link>
              </li>
              <li
                className={
                  pathname && pathname.includes("clients") ? "active" : ""
                }
              >
                <Link to="/clients">
                  <i className="fe fe-user" /> <span>Clients</span>
                </Link>
              </li>
              <li
                className={
                  pathname && pathname.includes("services") ? "active" : ""
                }
              >
                <Link to="/services">
                  <i className="fe fe-table" /> <span>Services</span>
                </Link>
              </li>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li className="menu-title">
                <span>{" "}</span>
              </li>
              <li className="menu-title">
                <span>User</span>
              </li>
              <li
                className={
                  pathname && pathname.includes("upcomingapp") ? "active" : ""
                }
              >
                <Link to="/appointments">
                  <i className="fe fe-clock" /> <span>Upcoming APP</span>
                </Link>
              </li>
              <li
                className={
                  pathname && pathname.includes("newapp") ? "active" : ""
                }
              >
                <Link to="/">
                  <i className="fe fe-calendar" /> <span>New App</span>
                </Link>
              </li>
              <li
                className={
                  pathname && pathname.includes("dashprofile") ? "active" : ""
                }
              >
                <Link to="/dashprofile">
                  <i className="fe fe-user-plus" /> <span>Profile</span>
                </Link>
              </li>
              <li
                className={
                  pathname && pathname.includes("settings") ? "active" : ""
                }
              >
                <Link to="/settings">
                  <i className="fe fe-vector" /> <span>Settings</span>
                </Link>
              </li>
              <li>
                <Link to="#" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt" />
                  <span>Logout</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
};
export default SidebarNav;
